import {BarChartHorizontal} from "./plotly/BarChartHorizontal";
import {Typography, useTheme} from "@mui/material";
import {useOutletContext} from "react-router";
import {useCallback, useEffect, useState} from "react";
import {apiGet} from "../utils";
import {buildV2QueryParams, hasDateFilters} from "../utils/filters";
import {LoadingSpinner} from "../utils/loading_spinner";
import {formatCurrency} from "../utils/formatters";

export const ProfitLeaksPanel = ({minimal = false}) => {
    const {navOptions, handleNavigate, filters} = useOutletContext();
    const theme = useTheme();
    const dims = theme.dimensions;
    const panelTheme = theme.palette.contentPanel;
    const indicatorTheme = theme.palette.indicator;

    const [profitLeaksData, setProfitLeaksData] = useState([]);
    const [totalImpact, setTotalImpact] = useState(0);
    const [loading, setLoading] = useState(false);

    const fetchProfitLeaksByLabel = useCallback(() => {
        if (!hasDateFilters(filters)) {
            return;
        }

        setLoading(true);
        const queryParams = buildV2QueryParams(filters);
        apiGet(`v2/profit-leaks/summary/by-label${queryParams}`, (resp) => {
            if (resp?.success) {
                const transformedData = resp.data.map(item => ({
                    name: item.label,
                    value: item.profitImpact || 0
                }));
                setProfitLeaksData(transformedData);

                const total = resp.data.reduce((sum, item) => sum + (item.profitImpact || 0), 0);
                setTotalImpact(total);
            }
            setLoading(false);
        });
    }, [filters]);

    useEffect(() => {
        fetchProfitLeaksByLabel();
    }, [fetchProfitLeaksByLabel]);

    const handleMinimalPanelClick = () => {
        handleNavigate(navOptions.audit.subMenu.auditLeaks);
    };

    const handleHeaderClick = () => {
        if (minimal) {
            handleMinimalPanelClick();
        } else {
            handleNavigate(navOptions.audit.subMenu.auditLeaks);
        }
    };
 
    return (
        <div style={{...panelTheme, marginTop: 30, padding: 10, width: !minimal ? dims.normalPanelWidth : dims.smallPanelWidth, minHeight: dims.smallPanelHeight}}>
            <Typography 
                variant="h5" 
                display="inline" 
                style={{marginLeft: 10, cursor: 'pointer'}} 
                onClick={handleHeaderClick}
            >
                Profit Leaks
            </Typography>
            { 
                loading ? 
                <LoadingSpinner message="Loading profit leaks..." /> : 
                <>
                    <Typography variant="h5" display="inline" style={{marginRight: 10, float: 'right', color: indicatorTheme.red}}>
                        {formatCurrency(totalImpact, true)}
                    </Typography>
                    <BarChartHorizontal title="Profit Leaks" data={profitLeaksData.length > 0 ? profitLeaksData : []}/>                </>
            }
        </div>
    );
};